import maatPro from './maat/index';

const bifWindow = typeof window === 'undefined' ? {} : window;

class HeartBeatPageTools {
  sum = 1;

  fastTime = 1000;

  fastMaxSum = 5; // 快速上报最大次数

  fastCurSum = 0;

  beatMaxSum = 200; // 心跳最大次数

  beatTime = 3000; // 心跳上报时间

  initVisibilityState = 0;

  // 间隔时间统计

  start(isInit = false) {
    this.beatEvent('first'); // 首次上报
    if (isInit) {
      this.sum = 1;
      this.beatStartFast();
    } else {
      this.beatStart();
    }
  }

  /**
   * 启动心跳上报
   * */
  beatStart() {
    if (bifWindow.maatBeatIntervaler) {
      this.stop();
    }
    bifWindow.maatBeatIntervaler = setInterval(this.beatEvent.bind(this, null), this.beatTime);
  }

  /**
   * 快速上报心跳极速模式
   * */
  beatStartFast() {
    if (bifWindow.maatBeatIntervaler) {
      this.stop();
    }
    bifWindow.maatBeatIntervaler = setInterval(this.beatEvent.bind(this, 'fast'), this.fastTime);
  }

  stop() {
    clearInterval(bifWindow.maatBeatIntervaler);
    // eslint-disable-next-line no-multi-assign
    this.maatBeatIntervaler = bifWindow.maatBeatIntervaler = null;
  }

  /**
   * 如果有多次只上报最后一个
   * */
  beatEvent(eventFlag = 'fast') {
    if (eventFlag === 'fast') {
      this.fastCurSum++;
    }
    this.sum++;
    maatPro.$heartBeatPage({
      interval_time: eventFlag === 'first' ? 0 : eventFlag === 'fast' ? this.fastTime : this.beatTime,
      beat_sum: this.sum,
    });

    if (this.fastCurSum >= this.fastMaxSum) {
      // 如果超过最大次数限制 关闭极速上报模式
      this.beatStart();
    }

    if (this.sum > this.beatMaxSum) {
      // 超过1000次停止上报 浪费资源
      this.stop();
    }
  }
}

export default new HeartBeatPageTools();
